import { GameController } from "@nolimitcity/slot-game/bin/core/gamecontroller/GameController";
import { PresentationManager } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/PresentationManager";
import { SanZeroManager } from "./zero/SanZeroManager";
import { SanParsedGameData } from "./server/data/SanParsedGameData";
import { SanParsedInitData } from "./server/data/SanParsedInitData";
import { Speedster } from "./debug/Speedster";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { WinPresentationEvent } from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SanQuentin} from "./SanQuentin";

export class SanGameController extends GameController{

    protected debugSpeedHandler(): void {
        const speedHack:Speedster =  new Speedster();
    }

    // #ScreenEvent.SKIP
    protected onGameStart(): void {
        const eventToBePlayed:string = this.presentationManager.isRestore ? SpinEvent.RESTORE : SpinEvent.INTRO;

        // *******
        if (!!this.config.developerTools && GameSetting.isDevMode) {
            this.debugSpeedHandler();
        }
        if (!!this.config.optimization) {
            this.OverFlowTickerRemoval();
        }

        const showPayoutOnStart =  SanQuentin.api.gameClientConfiguration.showPayoutOnStartup === true && !this.presentationManager.isRestore;
        //#251
        if( (!(NolimitApplication.apiPlugin.freeFeatureBet.hasFreeFeatureBet()) || this.presentationManager.isRestore) && !showPayoutOnStart) {
            this.presentationManager.playEvent(eventToBePlayed, () => EventHandler.dispatchEvent(new GameEvent(SpinEvent.STOPPED)));
        }
    }

    // #SpinEvent.STOPPED
    Presentation(): void {
        this.presentationManager.playEvent(WinPresentationEvent.WIN_PRESENTATIONS_STARTED, function () {
            EventHandler.dispatchEvent(new GameEvent(WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED));
        });
    };
    
    protected initExternalControllers():void{
        
         //  Presentation controllers
         this.presentationManager = new PresentationManager(this.config.PRESENTATIONS, this.config.checklog);
         // *******
 
         // Zero Controller
         this.zeroBetManager = new SanZeroManager();
         // ******
    }

    protected InitDataReceived(data:SanParsedInitData):void{
        super.InitDataReceived(data);
        SanZeroManager.setNextMode(data.nextMode,data.freespinsLeft!);
    };

    protected GameDataReceived(data:SanParsedGameData):void{
        super.GameDataReceived(data);
        SanZeroManager.setNextMode(data.nextMode,data.freespinsLeft!);
    }
}